// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { isCanada } from '@tcp/core/src/utils';
import PriceCurrency from '@tcp/core/src/components/common/molecules/PriceCurrency';
import ADDEDTOBAG_CONSTANTS from '@tcp/core/src/components/features/CnC/AddedToBag/AddedToBag.constants';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty.js';
import Col from '../../../../common/atoms/Col';
import Row from '../../../../common/atoms/Row';

import BodyCopy from '../../../../common/atoms/BodyCopy';
import styles from '../styles/AddedToBagViewPoints.style';
import withStyles from '../../../../common/hoc/withStyles';
import AddedToBagViewPointsLabels, {
  GLOBAL_ADD_TO_BAG_MODAL_LABELS,
} from './AddedToBagViewPoints.labels';

const getModifiedString = (totalItems) => {
  const addedToBagViewPointsLabels =
    getLabelFromCopyOrFromTranslation(GLOBAL_ADD_TO_BAG_MODAL_LABELS, AddedToBagViewPointsLabels) ||
    {};
  const subHeading = `<span>${addedToBagViewPointsLabels?.lbl_info_subTotal?.replace(
    '#items',
    `${totalItems !== 0 ? totalItems : ''}`
  )}</span>`;
  return (
    // eslint-disable-next-line react/no-danger
    <span dangerouslySetInnerHTML={{ __html: subHeading }} />
  );
};

const showPoints = (userPoints, isInternationalShipping, pointsApi) => {
  const pointsApiNAFlag = pointsApi && pointsApi.toUpperCase() === ADDEDTOBAG_CONSTANTS.NA;
  return userPoints !== 0 && !isCanada() && !isInternationalShipping && !pointsApiNAFlag;
};

const showPointsToNextRewards = (isInternationalShipping, pointsApi) => {
  const pointsApiNAFlag = pointsApi && pointsApi.toUpperCase() === ADDEDTOBAG_CONSTANTS.NA;
  return !isCanada() && !isInternationalShipping && !pointsApiNAFlag;
};

const getPointsColor = (isPlcc) => {
  if (isPlcc) {
    return 'blue.B100';
  }
  return 'orange.800';
};

const isPointsAvailable = (pointsSummary, isInternationalShipping) => {
  const { isBrierleyWorking } = pointsSummary;
  const isPointSummary =
    pointsSummary && Object.keys(pointsSummary).length > 0 && pointsSummary.totalItems > 0;
  return !isCanada() && !isInternationalShipping ? isBrierleyWorking : isPointSummary;
};
const calculateItemPrice = (itemPrice, offerPrice, isOptmisticAddToBagModal) => {
  return isOptmisticAddToBagModal ? itemPrice || offerPrice : itemPrice;
};

const getIsDataFetching = (isOptmisticAddToBagModal, pointsSummary, isInternationalShipping) => {
  return isOptmisticAddToBagModal
    ? isPointsAvailable(pointsSummary, isInternationalShipping)
    : true;
};

const AddedToBagViewPoints = ({
  className,
  pointsSummary,
  isPlcc,
  isInternationalShipping,
  isOptmisticAddToBagModal,
  offerPrice,
}) => {
  const addedToBagViewPointsLabels =
    getLabelFromCopyOrFromTranslation(GLOBAL_ADD_TO_BAG_MODAL_LABELS, AddedToBagViewPointsLabels) ||
    {};
  const { itemPrice, bagSubTotal, userPoints, pointsToNextReward, totalItems, pointsApi } =
    pointsSummary;
  const isDataFetching = getIsDataFetching(
    isOptmisticAddToBagModal,
    pointsSummary,
    isInternationalShipping
  );
  const itemPriceToDisplay = calculateItemPrice(itemPrice, offerPrice, isOptmisticAddToBagModal);
  const isShowPoints = showPoints(userPoints, isInternationalShipping, pointsApi);
  return (
    <BodyCopy
      fontSize="fs13"
      color="black"
      fontFamily="secondary"
      component="div"
      className={`${className}
        added-to-bag-points-wrapper
      `}
      tabIndex="0"
    >
      <div className={!isCanada() ? 'addedtobag-wrapper' : ''}>
        <Row className="row-padding" tabIndex="0">
          <Col colSize={{ large: 8, small: 4, medium: 6 }}>
            {renderLabel(addedToBagViewPointsLabels.lbl_info_price, 'lbl_info_price')}
          </Col>
          <Col
            data-locator="addedtobag-productprice"
            className="text-value"
            colSize={{ large: 4, small: 2, medium: 2 }}
          >
            {itemPriceToDisplay ? <PriceCurrency price={itemPriceToDisplay} /> : '-'}
          </Col>
        </Row>

        <Row className="divided-line" />
        <Row className="row-padding" tabIndex="0">
          <Col colSize={{ large: 8, small: 4, medium: 6 }}>
            {getModifiedString(totalItems || 0)}
          </Col>
          <Col
            data-locator="addedtobag-bagsubtotal"
            className={`text-value added-to-bag-subtotal`}
            colSize={{ large: 4, small: 2, medium: 2 }}
          >
            {bagSubTotal ? <PriceCurrency price={bagSubTotal} /> : '-'}
          </Col>
        </Row>
        {isShowPoints && (
          <Row className="row-padding" tabIndex="0">
            <Col colSize={{ large: 9, small: 5, medium: 6 }}>
              <BodyCopy
                fontSize="fs13"
                fontFamily="secondary"
                fontWeight="extrabold"
                className="total-bag-points"
              >
                {renderLabel(
                  addedToBagViewPointsLabels.lbl_info_totalRewardsInBag,
                  'lbl_info_totalRewardsInBag'
                )}
              </BodyCopy>
            </Col>
            <Col colSize={{ large: 3, small: 1, medium: 2 }}>
              <BodyCopy
                fontSize="fs13"
                data-locator="addedtobag-totalrewardpoints"
                fontFamily="secondary"
                className="text-value total-bag-points-value"
                color={getPointsColor(isPlcc)}
                fontWeight="extrabold"
              >
                {isDataFetching ? userPoints || 0 : '-'}
              </BodyCopy>
            </Col>
          </Row>
        )}
        {showPointsToNextRewards(isInternationalShipping, pointsApi) ? (
          <Row className="row-padding" tabIndex="0">
            <Col colSize={{ large: 8, small: 5, medium: 6 }}>
              <BodyCopy
                fontSize="fs13"
                fontFamily="secondary"
                fontWeight="extrabold"
                className="total-bag-points"
              >
                {renderLabel(
                  addedToBagViewPointsLabels.lbl_info_totalNextRewards,
                  'lbl_info_totalNextRewards'
                )}
              </BodyCopy>
            </Col>
            <Col colSize={{ large: 4, small: 1, medium: 2 }}>
              <BodyCopy
                fontSize="fs13"
                data-locator="addedtobag-totalpointsnextreward"
                fontFamily="secondary"
                className="text-value"
                color={getPointsColor(isPlcc)}
                fontWeight="extrabold"
              >
                {isDataFetching ? pointsToNextReward || 0 : '-'}
              </BodyCopy>
            </Col>
          </Row>
        ) : null}
      </div>
    </BodyCopy>
  );
};

AddedToBagViewPoints.propTypes = {
  className: PropTypes.string.isRequired,
  pointsSummary: PropTypes.shape.isRequired,
  isPlcc: PropTypes.bool.isRequired,
  isInternationalShipping: PropTypes.bool.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  isOptmisticAddToBagModal: PropTypes.bool.isRequired,
  offerPrice: PropTypes.number,
  isATBModalBackAbTestNewDesign: PropTypes.bool,
};

AddedToBagViewPoints.defaultProps = {
  isATBModalBackAbTestNewDesign: false,
};

export default withStyles(AddedToBagViewPoints, styles);
export { AddedToBagViewPoints as AddedToBagViewPointsVanilla };
